class Dropdownable extends HTMLElement {
  constructor (self) {
    self = super(self)
    self.init()
    return self
  }

  init () {
    this.mainClass = 'core-Dropdownable'
  }

  connectedCallback () {
    if (!this.classList.contains(this.mainClass)) {
      this.classList.add(this.mainClass)
    }
    this.classList.remove('core-Icon-spinner')
    this.setToggleEvent()
  }

  toggleThis (target) {
    const isMe = (target === this)
    const isChild = (target.closest(this.tagName) === this)
    // soon we will check if it is a nested dropdown
    if (isMe || isChild) {
      this.classList.toggle('open')
    } else {
      this.classList.remove('open')
    }
  }

  setToggleEvent () {
    document.body.addEventListener('click', (e) => this.toggleThis(e.target))
  }
}

export default Dropdownable
